import type { ReactNode } from 'react'

import { DatePicker } from '../date-picker'

export interface DateTimeRangeProps {
  from?: string
  to?: string
  onChange: (value: { from?: string; to?: string }) => void
  orientation?: 'horizontal' | 'vertical'
  fromLabel?: string
  toLabel?: string
  fromPlaceholder?: string
  toPlaceholder?: string
  minDate?: string
  maxDate?: string
  help?: ReactNode
  className?: string
}

const pad = (value: number) => String(value).padStart(2, '0')

export const toWallClock = (date: Date | null): string | undefined => {
  if (!date) return undefined
  return `${date.getFullYear()}-${pad(
    date.getMonth() + 1
  )}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:00`
}

const parseWallClock = (value?: string): Date | null => (value ? new Date(value) : null)

export function DateTimeRange({
  from,
  to,
  onChange,
  orientation,
  fromLabel,
  toLabel,
  fromPlaceholder,
  toPlaceholder,
  minDate,
  maxDate,
  help,
  className,
}: DateTimeRangeProps) {
  const layout = orientation === 'vertical' ? 'flex-col' : 'flex-col sm:flex-row'

  return (
    <div className={className}>
      <div className={`flex ${layout} gap-4`}>
        <DatePicker
          shouldShowTime
          label={fromLabel}
          placeHolderText={fromPlaceholder}
          initialDate={parseWallClock(from)}
          minDate={minDate}
          maxDate={maxDate}
          handleSet={(date) => onChange({ from: toWallClock(date) })}
        />
        <DatePicker
          shouldShowTime
          label={toLabel}
          placeHolderText={toPlaceholder}
          initialDate={parseWallClock(to)}
          minDate={from?.slice(0, 10) ?? minDate}
          maxDate={maxDate}
          handleSet={(date) => onChange({ to: toWallClock(date) })}
        />
      </div>
      {help}
    </div>
  )
}
